import ISection from "./ISection";
import { TUsernameAvailable } from "../Types/TUsernameAvailable";
import RestPromise from "../../../utils/RestPromise";
import CheckManagerFields from "../../Manager/CheckManagerFields";

export default class EmailSection implements ISection {
  private readonly _address: JQuery<HTMLInputElement>;
  private timer: NodeJS.Timeout | undefined;
  private lastCheckEmail: string;
  private lastEmailResult: TUsernameAvailable;
  private _isAvailable: boolean;

  constructor() {
    this._address = $("input[name*='form[email]']");

    this._address.on("keyup keypress blur change", () => {
      this.checkInputValidity();
      this.onChange();
    });

    if (this.address !== "") {
      this.CheckValidity();
    }
  }

  public static get isPresent(): boolean {
    return $("input[name*='form[email]']").length > 0;
  }

  public get isEmpty(): boolean {
    return this.address === "";
  }

  private _onChange: () => void;

  public get onChange(): () => void {
    return this._onChange;
  }

  public set onChange(callback: () => void) {
    this._onChange = callback;
  }

  private _onEmailValid: (email: string) => void;

  public get onEmailValid(): (email: string) => void {
    return this._onEmailValid;
  }

  public set onEmailValid(callback: (email: string) => void) {
    this._onEmailValid = callback;
  }

  public get address(): string {
    return this._address.val()?.trim();
  }

  public get isValid(): boolean {
    //If the mail field isn't present, we don't need to validate it
    if (this._address.length === 0) {
      return true;
    }

    // If the email field is empty, don't display any error
    if (this.address === "") {
      this.hideEmailErrors();
      return false;
    }

    if (!this._isAvailable) {
      return false;
    }

    this.hideEmailErrors();
    return true;
  }

  public CheckValidity(): void {
    this.checkInputValidity();
    if (!this.isValid && this.address === "") {
      CheckManagerFields.SetErrorInfo(this._address.parent());
      CheckManagerFields.DisplayError(
        this._address.parent(),
        $(".empty-name-message").text(),
      );
    }
    return;
  }

  private checkInputValidity(): void {
    clearTimeout(this.timer);
    if (this.address === "") {
      return;
    }

    this.timer = setTimeout(() => {
      this.checkMail(this.address).then((result: boolean | string) => {
        if (result === true) {
          this._isAvailable = true;
          this._onEmailValid(this.lastCheckEmail);
        } else {
          this._isAvailable = false;
          CheckManagerFields.DisplayError(
            this._address.closest(".input-section"),
            result.toString(),
          );
          CheckManagerFields.SetErrorInfo(
            this._address.closest(".input-section"),
          );
        }
        this.checkInputValidity();
        clearTimeout(this.timer);
      });
    }, 500);
  }

  private async checkMail(email: string): Promise<string | boolean> {
    if (this.lastCheckEmail && email === this.lastCheckEmail) {
      if (this.lastEmailResult.available) {
        return Promise.resolve(true);
      } else {
        return Promise.resolve(this.lastEmailResult.message);
      }
    }

    this.hideEmailErrors();
    CheckManagerFields.SetLoadingInfo(this._address.closest(".input-section"));
    // We make an ajax call to check the username
    const result: TUsernameAvailable = await RestPromise.Create(
      `/rest/username/${email}`,
      "GET",
    );
    this.lastCheckEmail = email;
    this.lastEmailResult = result;
    if (result.available) {
      return Promise.resolve(true);
    } else {
      return Promise.resolve(result.message);
    }
  }

  private hideEmailErrors(): void {
    CheckManagerFields.SetEmptyInfo(this._address.closest(".input-section"));
    CheckManagerFields.DisplayError(this._address.parent(), "");
  }
}
